import Dropdown from 'react-bootstrap/Dropdown'
import styled from 'styled-components'
import { focusedInput } from '~/components/CommonStyles'
import { dimensions, light, spacing } from '~/constants/theme'

export const StyledDropdownToggle = styled(Dropdown.Toggle)`
  width: 100%;
  height: 100%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${light.dark700};
  color: ${light.dark900};
  border-radius: ${dimensions.borderRadiusSM};
  box-sizing: border-box;
  background-color: ${light.gray100};
  &.btn-primary:focus,
  :hover,
  :active {
    background-color: ${light.gray200};
    border: 1px solid ${light.dark700};
  }
  &.btn-primary.dropdown-toggle:focus {
    ${focusedInput}
  }

  &::after {
    display: none !important;
  }

  > p {
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
export const StyledDropdownSettingsToggle = styled(Dropdown.Toggle)`
  width: 100%;
  height: 40px;
  padding: ${spacing.spacingLG} ${spacing.spacingMD};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1.5px solid ${light.gray400};
  color: ${light.dark900};
  border-radius: ${dimensions.borderRadiusXS};
  box-sizing: border-box;
  background-color: ${light.gray100};
  &.btn-primary:focus,
  :hover,
  :active {
    background-color: ${light.gray200};
    border: 1.5px solid ${light.gray400};
  }
  &.btn-primary.dropdown-toggle:focus {
    ${focusedInput}
  }

  &::after {
    display: none !important;
  }

  > p {
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

// parent
export const StyledDropdown = styled(Dropdown)`
  width: 100%;
  &.show > ${StyledDropdownToggle} {
    border: none;
    background-color: ${light.gray100};
  }
`

export const StyledDropdownMenu = styled(Dropdown.Menu)`
  width: 100%;
  max-height: 280px;
  overflow: auto;
  padding: ${spacing.spacingSM};
  border-radius: ${dimensions.borderRadiusSM};
  border: 1px solid ${light.dark700};
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.2);
  background-color: ${light.gray100};
`
export const StyledDropdownSettingsMenu = styled(Dropdown.Menu)`
  width: 100%;
  max-height: 280px;
  overflow: auto;
  padding: ${spacing.spacingSM};
  border-radius: ${dimensions.borderRadiusXS};
  border: 1.5px solid ${light.gray400};
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.14);
  background-color: ${light.gray100};
`

export const StyledMenuItem = styled(Dropdown.Item)`
  font-family: 'Inter', Helvetica, sans-serif;
  font-style: normal;
  font-weight: ${(props) => (props.active ? '600' : 'normal')};
  font-size: 14px;
  line-height: 17px;
  border-radius: ${dimensions.borderRadiusSM};
  color: ${light.dark900};
  padding: ${dimensions.borderRadiusMD};
  box-sizing: border-box;
  background-color: ${(props) =>
    props.active ? `${light.gray300}` : `${light.gray100}`};
  &.active,
  &:active {
    color: ${light.dark900};
    background-color: ${(props) =>
      props.active ? `${light.gray300}` : `${light.transparent}`};
  }
  &:hover {
    background-color: ${light.gray300};
  }
  &:active {
    background-color: ${light.gray400};
  }
`
